export default "__VITE_ASSET__B12_db5K__"